import { useMemo } from 'react';
import { pick } from 'ramda';
import { useAppSelector } from 'js/store/hooks';
import { getBaseDomain } from 'js/utils/url.util';

export const useOptions = (): SocketIOConnectOptions => {
    const { openApiDomain, openApiOptions } = useAppSelector(pick(['openApiDomain', 'openApiOptions']));

    return useMemo(() => ({
        'request timeout': 30000,
        'reconnection delay': 3000,
        'max reconnection attempts': Infinity,
        'reconnection limit': 3000,
        'connect timeout': 15000,
        'force new connection': true,
        reconnect: true,
        transports: ['websocket', 'xhr-polling'],
        url: openApiDomain.replace('[superdomain]', getBaseDomain()),
        ...openApiOptions
    }), [openApiDomain, openApiOptions]);
};
